import { countries } from './countries-intl.js';

const component = {

	/**
	 * Init module
	 */
	init: () => {
    window.theme = window.theme || {};
    window.theme.money = component;
    component.money_format = (typeof Shopify !== 'undefined' && Shopify.money_format) ? Shopify.money_format : "${{amount}}";
    component.initMoneyFormat();
	},

    /**
	 * MoneyFormat Shopify
     *
     * ${{ amount }} - Default
     * ${{ amount_no_decimals }}
     * ${{ money_with_currency }}
     * ${{ money_without_trailing_zeros }}
     * ${{ money_without_currency  }}
     *
	 * @returns {undefined}
	 */
	initMoneyFormat: () => {
		// component.format = function(cents, format) {
		// 	if (typeof cents == 'string') { cents = cents.replace('.',''); }
		// 	var value = '';
		// 	var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		// 	var formatString = (format || this.money_format);

		// 	function defaultOption(opt, def) {
		// 		return (typeof opt == 'undefined' ? def : opt);
		// 	}

		// 	function formatWithDelimiters(number, precision, thousands, decimal) {
		// 		precision = defaultOption(precision, 2);
		// 		thousands = defaultOption(thousands, ',');
		// 		decimal   = defaultOption(decimal, '.');

		// 		if (isNaN(number) || number == null) { return 0; }

		// 		number = (number/100.0).toFixed(precision);

		// 		var parts   = number.split('.'),
		// 			dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
		// 			cents   = parts[1] ? (decimal + parts[1]) : '';

		// 		return dollars + cents;
		// 	}

		// 	switch(formatString.match(placeholderRegex)[1]) {
		// 		case 'amount':
		// 		value = formatWithDelimiters(cents, 2);
		// 		break;
		// 		case 'amount_no_decimals':
		// 		value = formatWithDelimiters(cents, 0);
		// 		break;
		// 		case 'amount_with_comma_separator':
		// 		value = formatWithDelimiters(cents, 2, '.', ',');
		// 		break;
		// 		case 'amount_no_decimals_with_comma_separator':
		// 		value = formatWithDelimiters(cents, 0, '.', ',');
		// 		break;
		// 	}

		// 	return formatString.replace(placeholderRegex, value);
		// };

    const format = (value) => {
      const defaultCurrency = 'USD';
      const defaultCountry = 'US';
      const defaultLocale = 'en-US';

      const currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : defaultCurrency;
      const country = window.Shopify && window.Shopify.country ? window.Shopify.country : defaultCountry;
      const locale = window.Shopify && window.Shopify.country ? getDefaultLocaleByCountry(country) : defaultLocale;

      let formattedValue = value;

      try {
        const formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
        formattedValue = formatter.format(value / 100.0);
      } catch (error) {}

      return formattedValue;
    };

    const getDefaultLocaleByCountry = (countryCode) => {
      const defaultLocale = 'en-US';
      const country = countries.find(item => item.alpha2 === countryCode );
      return country ? country.default_locale : defaultLocale;
    };

    component.format = format;
  }
};

export default component;
